import { gql } from '@apollo/client'

export const galleryImagesLikeRemoveManyMutation = gql`
  mutation GalleryImagesLikeRemoveMany($user: String!, $image: String!) {
    galleryImagesLikeRemoveMany(filter: { user: $user, image: $image }) {
      numAffected
    }
  }
`
